import { CustomMultiSelectFieldProps, SelectField } from 'components/form'
import { StatusRegulacaoEnum } from 'graphql/types.generated'

import { RegulacaoEnumTextMap } from '../model-regulacao'

type StatusRegulacaoSelectFieldProps = CustomMultiSelectFieldProps<StatusRegulacaoEnum>

export function StatusRegulacaoSelectField(props: StatusRegulacaoSelectFieldProps) {
  const { ...rest } = props

  return <SelectField<StatusRegulacaoEnum> items={items} itemToString={itemToString} multiple {...rest} />
}

const items = Object.values(StatusRegulacaoEnum)
const itemToString = (item: StatusRegulacaoEnum): string => item && RegulacaoEnumTextMap[item]
